<template>

    <a class="ad_menu-item ad_menu-item--login"
        href="#"
        v-on:click="showLoginModale"
        v-if="ready && !isAuth">

        <i class="fa fa-user"></i>
        <span class="ad_menu-item__label">Espace client</span>

    </a>

</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

import { useLogin } from '@/helpers/auth'
import LoginModale, { LOGIN_EVENT, LoginBus } from '@/components/loginModale/LoginModale.vue'

export default {

    data() {
        return {
            modale: null,
            ready: false
        }
    },

    computed: mapState({

        isAuth: state => ( state.utilisateurs.current !== null )

    }),

    methods: {

        showLoginModale: function() {
            LoginBus.$emit(LOGIN_EVENT)
        }
    },

    created() {

        /// Invité (Utilisateur non authentifié),
        const { isLogged } = useLogin()
        if ( !isLogged )
        {            
            this.modale = new Vue({
                render: createElement => createElement(LoginModale)
            })
            this.modale.$mount(document.body.appendChild(document.createElement('div')))

            this.ready = true
        }
    },

    name: 'LoginLink'
}
</script>
